"use client";

import { Navigate } from "react-router-dom";
import { useTenant, type BusinessType } from "@/components/TenantProvider";
import Spinner from "@/components/Spinner";

interface AdminGuardProps {
  /** Business types allowed to access this admin route */
  types: BusinessType[];
  children: React.ReactNode;
}

/**
 * AdminGuard - Tenant-isolates admin pages by business type.
 *
 * Only renders children when the current tenant's `businessType`
 * matches one of the allowed `types`. Otherwise redirects to `/admin`.
 */
export default function AdminGuard({ types, children }: AdminGuardProps) {
  const { tenant, loading } = useTenant();

  if (loading) return <Spinner />;

  if (!types.includes(tenant.businessType)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
